import { render, staticRenderFns } from "./BotaoIcone.vue?vue&type=template&id=2e45fe3c&scoped=true&"
import script from "./BotaoIcone.vue?vue&type=script&lang=js&"
export * from "./BotaoIcone.vue?vue&type=script&lang=js&"
import style0 from "./BotaoIcone.vue?vue&type=style&index=0&id=2e45fe3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e45fe3c",
  null
  
)

export default component.exports